import React from "react";
import { HashRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import history from "./hooks/history";

// SERVICES
import AuthService from "~/services/auth";

// PAGES - PUBLIC
import PageLogin from "./pages/Public/Login";

// PAGES - PRIVATE
import PageHome from "./pages/Private/Home";

import PageFerramentasCertificadoDigital from "./pages/Private/Ferramentas/CertificadoDigital";
import PageCadastroAdministradores from "./pages/Private/Cadastros/Administradores";
import PageCadastroEmitentes from "./pages/Private/Cadastros/Emitentes";
import PageCadastroPSPs from "./pages/Private/Cadastros/EmitentesPSPs";

/**
 * Proteje as rotas privadas do sistema
 */
const PrivateRoutes = () => {

    const token = AuthService.getToken();
    window.useNavigate = useNavigate();

    if (token !== false) {
        return (
            <Routes>

                <Route path="/" element={<PageHome />} />

                <Route path="/cadastros/administradores" element={<PageCadastroAdministradores />} />
                <Route path="/cadastros/emitentes" element={<PageCadastroEmitentes />} />
                <Route path="/cadastros/emitentes/:emitente_id/psps" element={<PageCadastroPSPs />} />

                <Route path="/ferramentas/certificado-digital" element={<PageFerramentasCertificadoDigital />} />

                {/* <Route path="/dashboard" element={<PageDashboard />} />
                <Route path="/relatorios" element={<PageRelatorios />} /> */}

            </Routes>
        )
    } else {
        // retorna para o login
        return <Navigate to="/" />;
    }

};

/**
 * Rotas publicas do sistema
 */
const PublicRoutes = () => {
    // coloca o usenavigate no root
    window.useNavigate = useNavigate();

    // localização atual
    const location = useLocation();

    // verifica se já está logado
    const token = AuthService.getToken();

    // redireciona pra seção logada
    if (token !== false && location.pathname === '/') {
        // retorna para o login
        return <Navigate to="/app" />;
    }

    return (
        <Routes>
            <Route path="/" element={<PageLogin />} />
            <Route path="/app/*" element={<PrivateRoutes />} />
        </Routes>
    );
};

/**
 * Exportação padrão
 */
export default () => {
    return (
        <HashRouter history={history}>
            <PublicRoutes />
        </HashRouter>
    );
};
